import {
    BankruptcyType, Derogatory, DerogatoryType, DispositionType, UnderwritingBorrowerType
} from '@api';
import { rest } from 'msw';

import { getMockUrl } from '../../mocks/getMockUrl';


export const mocks = [
    rest.get(getMockUrl('/client/:clientId/loan/:loanId/derogatory'), (req, res, ctx) => res(
        ctx.status(200),
        ctx.json(mockDerogatories)
    )),
    rest.post(getMockUrl('/client/:clientId/loan/:loanId/derogatory'), async (req, res, ctx) => {
        const newDerogatory = await req.json() as Derogatory;
        const createdDerogatory = {
            ...newDerogatory,
            id: String(mockDerogatories.length + 1)
        };

        return res(
            ctx.status(201),
            ctx.json(createdDerogatory)
        );
    }),
    rest.put(getMockUrl('/client/:clientId/loan/:loanId/derogatory/:id'), async (req, res, ctx) => {
        const { id } = req.params;
        const updatedDerogatory = await req.json() as Derogatory;

        return res(
            ctx.status(200),
            ctx.json({
                ...updatedDerogatory,
                id
            })
        );
    }),
    rest.delete(getMockUrl('/client/:clientId/loan/:loanId/derogatory/:id'), (req, res, ctx) => res(
        ctx.status(204)
    ))
];

export const mockDerogatories: Derogatory[] = [
    {
        id: '1',
        type: DerogatoryType.BANKRUPTCY,
        borrower: UnderwritingBorrowerType.BORROWER,
        bankruptcyType: BankruptcyType.CHAPTER_SEVEN,
        disposition: DispositionType.DISCHARGED,
        extenuating: 'Medical issues',
        date: '2020-05-15'
    },
    {
        id: '2',
        type: DerogatoryType.FORECLOSURE,
        borrower: UnderwritingBorrowerType.COBORROWER,
        disposition: DispositionType.DISMISSED,
        extenuating: 'Job loss',
        date: '2019-08-22'
    },
    {
        id: '3',
        type: DerogatoryType.LIEN,
        borrower: UnderwritingBorrowerType.BORROWER,
        plaintiff: 'City of Springfield',
        amount: 5000,
        disposition: DispositionType.OPEN,
        payingOff: true,
        date: '2021-03-10'
    },
    {
        id: '4',
        type: DerogatoryType.OPEN_COLLECTIONS,
        borrower: UnderwritingBorrowerType.BOTH,
        company: 'ABC Collections',
        accountNumber: '98765432',
        amount: 2500,
        date: '2022-01-05'
    }
];
